export class ItemFilter {
  searchText: string;
  rValueId: number;
  itemTypeId: number;
  statusId: number;
}
